import { Tooltip, styled } from "@mui/material";
import clsx from "clsx";
import { useDispatch } from "react-redux";
import { IDownloadAction } from "../../features/download/redux/download.actions";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";

interface IOwnProps {
    label?: string;
    disabled?: boolean;
    downloadAction: () => IDownloadAction;
}

const DownloadLocations = ({
    label,
    downloadAction,
    disabled,
    className,
}: IWithClassName & IOwnProps) => {
    const dispatch = useDispatch();

    const handleDownloadClick = () => {
        if (!disabled) {
            dispatch(downloadAction());
        }
    };

    return (
        <Tooltip title="Download this list">
            <span
                className={clsx(className, { disabled })}
                onClick={handleDownloadClick}
            >
                <img
                    src="/assets/download-icon.svg"
                    alt="download icon"
                    className="download-icon"
                />
                {label && <p>{label}</p>}
            </span>
        </Tooltip>
    );
};

export default styled(DownloadLocations)(({ theme }: IWithThemeProps) => ({
    display: "flex",
    color: theme?.palette.text.primary,
    cursor: "pointer",

    "&.disabled": {
        opacity: 0.3,
        cursor: "default",
    },

    ".download-icon": {
        paddingRight: theme?.spacing(1),
    },
}));
